import role from "@/http/requests/role"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      role.fetch().then(response => {
        commit('SET_ROLES', response.data.data.roles)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
